import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';

import Button from '@/src/components/common/Elements/Button/Button';
import LongTextByWidth from '@/src/components/common/Elements/LongText/LongTextByWidth';
import { DEFAULT_DATE_FORMAT } from '@/src/config';
import {
  Authorization,
  checkAccess,
  INTERNAL_USER_ROLES,
} from '@/src/lib/authorization/authorization';
import { RootState } from '@/src/reducers/types';

import { GoogleDriveFolderItem } from './GoogleDriveCard';

type GoogleDriveAccountCardProps = {
  account: GoogleDriveFolderItem;
  connectedOn: string;
  userId: number;
  email: string;
  onSelectAccessToken: (token?: string) => void;
  onDisconnect: (userId: number) => void;
  className?: string;
};
export const GoogleDriveAccountCard = ({
  account,
  connectedOn,
  email,
  userId,
  onDisconnect,
  className,
}: GoogleDriveAccountCardProps) => {
  const connectedOnFormatted = moment(connectedOn).format(DEFAULT_DATE_FORMAT);
  const loggedUser = useSelector((store: RootState) => store.loggedUser);
  const canDisconnect =
    checkAccess({ user: loggedUser.data, allowedRoles: INTERNAL_USER_ROLES }) ||
    loggedUser.data.id === userId;

  return (
    <div className={className} key={connectedOnFormatted}>
      <div className="tw-flex tw-justify-between tw-py-[15px] tw-px-[20px] tw-border-solid tw-border-[2px] tw-rounded-[5px]">
        <div className="tw-flex tw-items-center">
          <span className="tw-text-cfo-blue-600"> {email} </span>&nbsp;connected and synced&nbsp;
          <LongTextByWidth
            id={`an_${account.folderId}`}
            className="tw-text-cfo-blue-600 tw-underline tw-leading-[21px]"
            maxWidth={433}
            value={account.folderName}
          />
          &nbsp;on {connectedOnFormatted}.
        </div>
        <Authorization policyCheck={canDisconnect}>
          <Button onClick={() => onDisconnect(userId)} className="!tw-w-[100px]">
            Disconnect
          </Button>
        </Authorization>
      </div>
    </div>
  );
};
